export default "__VITE_ASSET__BUb9rcbt__"